import { createSlice } from '@reduxjs/toolkit'
import TeamInterface from '../../interfaces/Team.interface'

const initialState: TeamInterface = {

}

export const teamSlice = createSlice({
    name: 'team',
    initialState,
    reducers: {
        setTeam: (_, { payload }) => payload,
        addTeamMember: (state, { payload }) => {
            state.team_members?.push(payload)
        },
        deleteTeamMember: (state, { payload }) => {
            state.team_members = state.team_members?.filter(member => member.id !== payload)
        },
        toggleTeamMemberAdmin: (state, { payload }) => {
            const member = state.team_members?.find(member => member.id === payload)
            if (member) {
                member.admin = !member.admin
            }
        },
        resetTeam: () => initialState
    }
})
export const { setTeam, resetTeam, addTeamMember, deleteTeamMember,toggleTeamMemberAdmin } = teamSlice.actions
export default teamSlice.reducer